// @mui material components
import Card from "@mui/material/Card";

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftComponents/SoftBox";
import SoftTypography from "components/SoftComponents/SoftTypography";

import DataTable from "components/Tables/DevicesTable";

import {
    QueryClient,
    QueryClientProvider,
    useQuery,
} from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'

import bksAPI from 'services/api/bks';
import inspectionAPI from 'modules/inspections/api';
import { calculateBattery, processDevicesData } from "utils/device";
import { getUserAccessLevel } from "utils/setup";

import { useLocation, useMatch, useNavigate } from 'react-router-dom';
import { useAuth0, withAuthenticationRequired } from "@auth0/auth0-react";

import PropTypes from 'prop-types';
import { useEffect } from "react";
import { Box, CircularProgress, Container, Grid, Tooltip } from "@mui/material";
import moment from "moment";
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import UptimeDoughnutChart from "components/Charts/StatisticCards/UptimeDoughnutChart";

import { wrapper, loadingScreen } from "utils/wrapper";
import { disableMap } from "utils/map";
import CreateAssignment from "pages/components/Operations/CreateAssignment";
import { useSoftUIController } from "hooks/context";

function NewAssignmentView({ map, user }) {
    disableMap(map);

    // Queries
    bksAPI.loadToken(useAuth0());
    inspectionAPI.loadToken(useAuth0());
    const navigate = useNavigate();


    const [controller] = useSoftUIController();
    const { deviceLayout } = controller;

    const { inspection_record_id } = useMatch('operations/assignments/:inspection_record_id').params;

    const devices = useQuery({
        queryKey: ['getAllDevices'],
        queryFn: async () => {
            return await bksAPI.getAllDevices()
        },
        // staleTime: 30 * 1000
    });

    const inspection_record = useQuery({
        queryKey: ['getInspectionByRecordID', inspection_record_id],
        queryFn: async () => {
            return await inspectionAPI.getInspectionByRecordID(inspection_record_id)
        }
    });

    if (devices.isLoading || inspection_record.isLoading) {
        return loadingScreen(deviceLayout, true);
    }

    if (devices.error || inspection_record.error) {
        return wrapper((
            <SoftBox p={3} lineHeight={1}>
                <SoftTypography variant="h5" fontWeight="medium">
                    {"An error has occurred!"}
                </SoftTypography>
            </SoftBox>
        ), deviceLayout, true
        );
    }

    const devices_data = processDevicesData(devices.data, true);

    if (inspection_record.data.inspection.status == "resolved" || inspection_record.data.inspection.status == "inspected") {
        navigate('/');
    }
    else {
        return (
            wrapper((
                <Box display="flex" justifyContent="center">
                    <SoftBox sx={{ width: "100%", maxWidth: "1400px" }}>
                        <CreateAssignment selected_user={user} all_devices={devices_data} inspection_data={inspection_record.data.inspection} />
                    </SoftBox>
                </Box>
            ), deviceLayout, true
            )
        );
    }
}

NewAssignmentView.propTypes = {
    map: PropTypes.object,
    user: PropTypes.object
}

export default NewAssignmentView;
